module.exports = __webpack_public_path__ + "mh.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/mh.svg
// module id = 688
// module chunks = 0